import React, { useContext } from 'react';
import AccordionContext from 'react-bootstrap/AccordionContext';
import { useAccordionToggle } from 'react-bootstrap/AccordionToggle';
import Card from 'react-bootstrap/Card';
import _ from 'lodash'

export default function FilterHeader({ children, eventKey, name }) {
  const decoratedOnClick = useAccordionToggle(eventKey, () =>
    console.log('totally custom!'),
  );

  const isCurrentEventKey = (eventKey) => eventKey === currentEventKey;

  const currentEventKey = useContext(AccordionContext);

  return (
    <React.Fragment>
        <Card.Header 
            className="text-primary bg-white"
            onClick={ decoratedOnClick }>
          <button 
            className="text-primary filter-header-button" 
            aria-label="Close">
            <span aria-hidden="true">
                { isCurrentEventKey(eventKey) ? '-' : '+' }
            </span>
          </button>
          <h6 className="my-1">{ _.capitalize(name) }</h6>
        </Card.Header>
    </React.Fragment>
  );
}
